import ShopArticlesListModelBase from '../_generated/modelBases/shop-articles-list-model-base';

export default class ShopArticlesListModel extends ShopArticlesListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
